import { render, staticRenderFns } from "./L2tpAccount.vue?vue&type=template&id=656a3e49&"
import script from "./L2tpAccount.vue?vue&type=script&lang=js&"
export * from "./L2tpAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports